module.exports = __webpack_public_path__ + "img/cun_es.30e72c6d.jpg";